import { render, staticRenderFns } from "./CardUpdateAction.vue?vue&type=template&id=280cf265"
import script from "./CardUpdateAction.vue?vue&type=script&lang=js"
export * from "./CardUpdateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports